import stateStore from '../stateStore';
import { cancelCsvExport } from '../utils/csv/csvExport';
import { globalService } from './globalState/globalStateSlice';
import { bankDetailsService } from './payments/bankDetailSlice';
import { invitationService } from './permissions/invitationSlice';
import { userService } from './permissions/userSlice';
import { notificationService } from './shared/notificationSlice';
import { settingService } from './shared/settingSlice';
import { workspaceService } from './workspaces/workspaceSlice';

export const reduxServices = {
  bankDetails: bankDetailsService,
  globalState: globalService,
  invitation: invitationService,
  notification: notificationService,
  resetAppState: () => {
    // An export outlives page changes, so it would otherwise keep fetching and
    // could still save personal data after the member has signed out.
    cancelCsvExport();

    return Promise.all([
      stateStore.dispatch(userService.actions.reset()),
      stateStore.dispatch(workspaceService.actions.reset()),
      stateStore.dispatch(bankDetailsService.actions.reset()),
    ]);
  },
  setCurrentError: (error: any) => {
    return stateStore.dispatch(
      reduxServices.globalState.actions.setCurrentError(error),
    );
  },
  setting: settingService,
  showErrorModal: (isOpen: boolean) => {
    return stateStore.dispatch(
      reduxServices.globalState.actions.setShowErrorModal(isOpen),
    );
  },
  showErrorPage: (isOpen: boolean) => {
    return stateStore.dispatch(
      reduxServices.globalState.actions.setShowErrorPage(isOpen),
    );
  },
  user: userService,
  workspace: workspaceService,
};
